const contextUrl = 'https://schema.org'

const getAbsoluteUrl = (href: string): string => {
    if (typeof window === 'undefined') {
        return href
    }

    return href.startsWith('/')
        ? `${window.location.protocol}//${window.location.host}${href}`
        : `${window.location.protocol}//${window.location.host}/${href}`
}

export {
    contextUrl,
    getAbsoluteUrl
}
